function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M6.584 2.79a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M7.248 1.926a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078c.32.056.548.334.554.656.004.258.404.258.4 0A1.083 1.083 0 006.93.92a1.067 1.067 0 00-1.16.322 1.074 1.074 0 00-.098 1.234 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.26-.396-.26-.4-.002zM6.584 5.822a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M7.248 4.958a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078c.32.054.548.334.554.656.004.258.404.258.4 0a1.083 1.083 0 00-.718-1.006 1.067 1.067 0 00-1.16.322 1.074 1.074 0 00-.098 1.234 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.26-.396-.26-.4-.002zM6.584 8.936a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M7.248 8.072a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078c.32.054.548.334.554.656.004.258.404.258.4 0a1.083 1.083 0 00-.718-1.006 1.067 1.067 0 00-1.16.322 1.074 1.074 0 00-.098 1.234 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.26-.396-.26-.4-.002zM3.414 2.802a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M4.078 1.938a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078.67.67 0 01.554.656c.004.258.404.258.4 0A1.083 1.083 0 003.76.932a1.067 1.067 0 00-1.16.322 1.074 1.074 0 00-.098 1.234 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.26-.396-.26-.4-.002zM3.414 5.834a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M4.078 4.97a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078.67.67 0 01.554.656c.004.258.404.258.4 0a1.083 1.083 0 00-.718-1.006 1.067 1.067 0 00-1.16.322 1.074 1.074 0 00-.098 1.234 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.26-.396-.26-.4-.002zM3.414 8.948a.864.864 0 100-1.728.864.864 0 000 1.728z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFCFCF",
  d: "M4.078 8.084a.672.672 0 01-.424.62.674.674 0 01-.754-.198.666.666 0 01.624-1.078c.322.054.55.334.554.656.004.258.404.258.4 0a1.083 1.083 0 00-.718-1.006A1.067 1.067 0 002.6 7.4a1.07 1.07 0 00-.098 1.232 1.08 1.08 0 001.13.494c.494-.094.838-.55.846-1.042.004-.258-.396-.258-.4 0z"
});

var SvgDrag = function SvgDrag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag.d7e93477.svg";
export { ForwardRef as ReactComponent };